<template>
  <div class="brief-rank-zone__wrapper">
    <div class="brief-rank-zone__no-data" v-if="isAllSnapshotsEmpty">Awaiting Data</div>
    <div class="brief-rank-zone" v-else>
      <div class="common-table__row common-table__header">
        <div class="common-table__header-cell brief-rank-zone__first">Rank Zone Snapshot</div>
        <div v-for="cell in commonCells"
             :key="cell"
             class="common-table__header-cell">{{cell}}
        </div>
        <div class="brief-rank-zone__last common-table__header-cell">Total</div>
      </div>
      <template v-for="rowIndex in rows">
        <div :key="rowIndex" class="common-table__row">
          <div class="common-table__cell brief-rank-zone__first"
               v-if="selectedSnapshots[rowIndex]">
            <base-select class="brief-rank-zone__select"
                         v-model="selectedSnapshots[rowIndex]"
                         :options="preparedSnapshots"
                         borderLess
                         :selectStyle="{height: '59px!important'}"
                         @change="changeDate(rowIndex)"
            />
          </div>
          <div v-if="!isDataFetched[rowIndex]"
               class="common-table__cell brief-rank-zone__loader-wrap">
            <base-horizontal-loader class="brief-rank-zone__loader"/>
          </div>
          <div v-else-if="isSnapshotDataEmpty[rowIndex]"
               class="common-table__cell brief-rank-zone__no-data">Awaiting Data
          </div>
          <template v-else>
            <div v-for="cell in commonCells"
                 :key="cell"
                 class="common-table__cell brief-rank-zone__cell_clickable"
                 @click="openModal(cell, rowIndex)">
              <span v-tooltip.top-middle="{content: getTooltipText(snapshotsData[rowIndex], cell), ...rzTooltipOptions}">
                {{snapshotsData[rowIndex][tableType][cell] | commaDividedNumber}}
              </span>
            </div>
            <div class="common-table__cell brief-rank-zone__last">
              <span v-tooltip.top-middle="{content: getTooltipText(snapshotsData[rowIndex], 'total_msv'), ...rzTooltipOptions}">
                {{snapshotsData[rowIndex][tableType]['total_msv'] | commaDividedNumber}}
              </span>
            </div>
          </template>
        </div>
      </template>
    </div>
    <modal name="movement"
           v-bind="modalProps"
    >
      <KeywordMovementTable :clickedItem="clickedItem"
                            :cellName="cellName"
                            :item="clickedItem"
                            :webPropertyGroupId="webPropertyGroupSelected._id"
                            :isReport="false"
                            @close="closeModal" />
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import filters from '@/common/Filters'
import helper from '@/services/Helper'
import { convertAdvancedOptionsToFilters } from '@/features/reports/common/advanced-options/config'
import baseModalProps from '@/common/BaseModalProps'
// import KeywordMovementTable from './KeywordMovementTable'
/**
   *  Component is used in {@link Reporting} tab
   *  Pay attention: this component works as trigger for api calls unlike from
   *  other components in which parent component triggers api calls nad sends data to child
   */
export default {
  name: 'RankZone',
  /**
   * Used import to work with async components
   */
  components: { KeywordMovementTable: () => import('./KeywordMovementTable') },
  props: {
    tableType: {
      type: String,
      default: 'msv'
    },
    selectedAdvancedOptions: {
      type: Array,
      default: () => []
    },
    webPropertyGroupSelected: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      commonCells: [
        '01 - 03',
        '04 - 07',
        '08 - 10',
        '11 - 25',
        '26 - 50',
        '51 - 100',
        'NR',
        'ND'
      ],
      isDataFetched: {
        0: false,
        1: false
      },
      rows: [0, 1],
      selectedSnapshots: [],
      snapshots: [],
      clickedItem: {},
      cellName: null
    }
  },
  created () {
    if (!this.snapshots.length) {
      this.isDataFetched[0] = true
      this.isDataFetched[1] = true
    }
  },
  watch: {
    /**
       * api call is posible only after receiving snapshot date from BE
       */
    'briefContent.snapshots': {
      handler (value) {
        if (!value.length || this.isSameSnapshots(value, this.snapshots)) {
          return
        }
        const copy = _.cloneDeep(value)
        this.snapshots = helper.sortSnapshots(copy)
        this.prepareSelectedSnapshots()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('briefContent', ['briefContent']),
    preparedSnapshots () {
      return this.snapshots.map(snapshot => ({
        label: this.$options.filters.formattedDate(snapshot),
        value: snapshot
      }))
    },
    snapshotsData () {
      return this.briefContent.snapshotsData || []
    },
    isSnapshotDataEmpty () {
      return [
        !this.checkSnapshotData(0),
        !this.checkSnapshotData(1)
      ]
    },
    isAllSnapshotsEmpty () {
      return this.isSnapshotDataEmpty[0] && this.isSnapshotDataEmpty[1]
    },
    rzTooltipOptions () {
      const options = {
        classes: 'rfx-tooltip-arrow'
      }
      return Object.assign({}, this.tooltipOptions, options)
    },
    briefId () {
      return this.$route.params.id
    },
    modalProps: function () {
      const shareModalProps = {
        width: '1200px'
      }
      return { ...baseModalProps, ...shareModalProps }
    }
  },
  methods: {
    ...mapActions('briefContent', [
      'getSnapshotData'
    ]),
    /**
       * set snapshots for first and second rows in the table
       */
    prepareSelectedSnapshots () {
      const firstSnapshotIndex = 1
      const secondSnapshotIndex = 0

      this.selectedSnapshots = [
        this.snapshots[firstSnapshotIndex],
        this.snapshots[secondSnapshotIndex]
      ]
    },
    /**
       * update row data after changing snapshot
       * */
    async updateData () {
      const snapshotDate1 = this.selectedSnapshots[0]
      const snapshotDate2 = this.selectedSnapshots[1]

      if (!snapshotDate1) {
        this.isDataFetched[0] = true
        return
      }

      if (!snapshotDate2) {
        this.isDataFetched[1] = true
        return
      }
      this.isDataFetched[0] = false
      this.isDataFetched[1] = false
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)

      await this.getSnapshotData({
        clientId: this.clientId,
        filters: {
          advancedFilters,
          snapshotDate1,
          snapshotDate2,
          contentBriefId: this.briefContent._id,
          web_property_group_id: this.webPropertyGroupSelected._id,
          index1: 0,
          index2: 1
        }
      }).catch(e => {
      })
      this.isDataFetched[0] = true
      this.isDataFetched[1] = true
    },
    /**
       * get table data
       * @params initial - false if update loader should be shown true - otherwise
       * */
    async getData ({ index1 = 0, index2 = 1, advancedFilters } = {}) {
      const snapshotDate1 = this.selectedSnapshots[index1]
      const snapshotDate2 = this.selectedSnapshots[index2]

      if (!snapshotDate1) {
        this.isDataFetched[index1] = true
        return
      }

      if (!snapshotDate2) {
        this.isDataFetched[index2] = true
        return
      }
      this.isDataFetched[index1] = false
      this.isDataFetched[index2] = false
      // const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      await this.getSnapshotData({
        clientId: this.clientId,
        filters: {
          advancedFilters,
          snapshotDate1,
          snapshotDate2,
          contentBriefId: this.briefContent._id,
          web_property_group_id: this.webPropertyGroupSelected._id,
          index1,
          index2
        }
      }).catch(e => {
      })
      this.isDataFetched[index1] = true
      this.isDataFetched[index2] = true
    },
    changeDate (index) {
      this.updateData(index)
    },
    getTooltipText (item, cellName) {
      const tooltipType = this.tableType === 'msv' ? 'keyword' : 'msv'
      const tooltipTypeText = tooltipType === 'msv' ? 'MSV' : 'Keyword Count'
      return `${tooltipTypeText}: ${filters.commaDividedNumber(item[tooltipType][cellName])}`
    },
    /**
       * check if snapshot data with passed index empty
       * @param index of snapshot
       * @returns {boolean}
       */
    checkSnapshotData (index) {
      const data = this.snapshotsData[index] || {}
      return !this.isDataFetched[index] || Object.keys(data).length > 0
    },
    isSameSnapshots (input = [], sorted = []) {
      if (sorted.length !== input.length) {
        return false
      }
      return input.every(item => sorted.includes(item))
    },
    /**
       * Opens {@link KeywordMovementTable} modal
       * @param cellName
       * @param index - index of snapshot (0, 1)
       */
    openModal (cellName, index) {
      this.cellName = cellName
      this.clickedItem = {}
      this.clickedItem.rank_zone = cellName.replace(' - ', '_')
      this.clickedItem.snapshot_date_from = this.selectedSnapshots[index]
      const toIndex = index === 0 ? 1 : 0
      this.clickedItem.snapshot_date_to = this.selectedSnapshots[toIndex]
      this.$modal.show('movement')
    },
    closeModal () {
      this.$modal.hide('movement')
    }
  },
  filters: {
    ...filters
  }
}
</script>

<style scoped lang="scss">

  .common-table {
    &__header {
      position: relative;
      background-color: rgba(1, 22, 39, 0.1);
    }

    &__header-cell {

      @include ellipsis;
      color: $rfx-dark-march;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 14px;

    }

    &__cell {
      color: $rfx-light-march;

      &:first-child {
        padding: 0 20px 0 0;
        display: flex;
        align-items: center;
        height: 60px;
      }
    }
  }

  .brief-rank-zone {
    display: flex;
    flex-direction: column;

    &__wrapper {
      background-color: #fff;
      border-radius: 13px;
      flex: 1 1 100%;
    }
    &__no-data {
      font-size: 27px;
      font-weight: 600;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      color: $rfx-light-march;
      padding: 30px 0;
    }

    &__cell{

      &_clickable {
        cursor: pointer;
        color: $rfx-bright-blue;

        &:hover{
          text-decoration: underline;
        }
      }
    }

    &__first {
      flex: 0 0 200px;
      box-sizing: border-box;
      border-top-left-radius: $rfx-default-border-radius;
    }

    &__last {
      flex: 0 0 100px;
      box-sizing: border-box;
      border-top-right-radius: $rfx-default-border-radius;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__no-data {
      font-size: 27px;
      font-weight: 600;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
    }

    &__loader-wrap {
      height: 60px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0;
      position: relative;
    }

    &__loader {
      position: absolute;
      top: -2px;
      left: 50%;
      transform: translateX(-50%);
    }

    &__table {
      margin-top: 40px;
      max-height: calc(85vh - 245px);
      display: flex;
      flex-direction: column;
    }

    &__select {
      flex: 1 1;
      color: $rfx-dark-march;
      font-weight: bold;
    }
  }

</style>
